import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "ui-menu-dashboard",
  "use": "ui-menu-dashboard-usage",
  "viewBox": "0 0 48 48",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 48 48\" id=\"ui-menu-dashboard\"><g id=\"ui-menu-dashboard_asus_proart_sw_ico_dashboard\"><rect width=\"48\" height=\"48\" fill=\"none\" /><path d=\"M39.66,30.62A17,17,0,1,1,17.2,8.41a1,1,0,1,1,.8,1.83,15,15,0,1,0,19.82,19.6,1,1,0,0,1,1.31-.53A1,1,0,0,1,39.66,30.62ZM41,24a1,1,0,0,1-1,1H24a1,1,0,0,1-1-1V8a1,1,0,0,1,1-1A17,17,0,0,1,41,24Zm-2-1A15,15,0,0,0,25,9V23Z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol